import { g as y, r as w, a as R, R as W } from "../../render-island-BMViq2-G.js";
import { W as G, y as I, z as K, e as Q, b as U, f as X, h as Y, i as Z, j as tt, k as et, l as st, m as ot, n as nt, d as rt, o as at, p as ut, q as ct, c as it, s as lt, t as ft, v as dt, x as mt, u as ht, w as At } from "../../render-island-BMViq2-G.js";
export * from "jotai";
import { atomEffect as wt, observe as vt, withAtomEffect as St } from "jotai-effect";
import _, { useCallback as A, useContext as x, createContext as C, useReducer as E, useEffect as P, useDebugValue as k, useMemo as p } from "react";
const F = {}, j = C(
  void 0
);
function g(t) {
  const e = x(j);
  return t?.store || e || y();
}
const m = (t) => typeof t?.then == "function", h = (t) => {
  t.status || (t.status = "pending", t.then(
    (e) => {
      t.status = "fulfilled", t.value = e;
    },
    (e) => {
      t.status = "rejected", t.reason = e;
    }
  ));
}, D = _.use || // A shim for older React versions
((t) => {
  if (t.status === "pending")
    throw t;
  if (t.status === "fulfilled")
    return t.value;
  throw t.status === "rejected" ? t.reason : (h(t), t);
}), d = /* @__PURE__ */ new WeakMap(), v = (t, e) => {
  let o = d.get(t);
  return o || (o = new Promise((r, s) => {
    let u = t;
    const i = (n) => (a) => {
      u === n && r(a);
    }, l = (n) => (a) => {
      u === n && s(a);
    }, c = () => {
      try {
        const n = e();
        m(n) ? (d.set(n, o), u = n, n.then(i(n), l(n)), w(n, c)) : r(n);
      } catch (n) {
        s(n);
      }
    };
    t.then(i(t), l(t)), w(t, c);
  }), d.set(t, o)), o;
};
function M(t, e) {
  const { delay: o, unstable_promiseStatus: r = !_.use } = e || {}, s = g(e), [[u, i, l], c] = E(
    (a) => {
      const f = s.get(t);
      return Object.is(a[0], f) && a[1] === s && a[2] === t ? a : [f, s, t];
    },
    void 0,
    () => [s.get(t), s, t]
  );
  let n = u;
  if ((i !== s || l !== t) && (c(), n = s.get(t)), P(() => {
    const a = s.sub(t, () => {
      if (r)
        try {
          const f = s.get(t);
          m(f) && h(
            v(f, () => s.get(t))
          );
        } catch {
        }
      if (typeof o == "number") {
        setTimeout(c, o);
        return;
      }
      c();
    });
    return c(), a;
  }, [s, t, o, r]), k(n), m(n)) {
    const a = v(n, () => s.get(t));
    return r && h(a), D(a);
  }
  return n;
}
function b(t, e) {
  const o = g(e);
  return A(
    (...s) => {
      if ((F ? "production" : void 0) !== "production" && !("write" in t))
        throw new Error("not writable atom");
      return o.set(t, ...s);
    },
    [o, t]
  );
}
function V(t, e) {
  return [
    M(t, e),
    // We do wrong type assertion here, which results in throwing an error.
    b(t, e)
  ];
}
const z = {};
function L(t, e) {
  const o = b(t, e);
  return A(() => o(W), [o]);
}
function N(t, e, o) {
  (z ? "production" : void 0) !== "production" && console.warn(
    "[DEPRECATED] useReducerAtom is deprecated and will be removed in the future. Please create your own version using the recipe. https://github.com/pmndrs/jotai/pull/2467"
  );
  const [r, s] = V(t, o), u = A(
    (i) => {
      s((l) => e(l, i));
    },
    [s, e]
  );
  return [r, u];
}
function q(t, e) {
  const o = p(
    () => R(null, (r, s, ...u) => t(r, s, ...u)),
    [t]
  );
  return b(o, e);
}
const S = /* @__PURE__ */ new WeakMap();
function J(t, e) {
  const o = g(e), r = H(o);
  for (const [s, ...u] of t)
    (!r.has(s) || e?.dangerouslyForceHydrate) && (r.add(s), o.set(s, ...u));
}
const H = (t) => {
  let e = S.get(t);
  return e || (e = /* @__PURE__ */ new WeakSet(), S.set(t, e)), e;
};
export {
  W as RESET,
  G as WithAtom,
  I as WithAtoms,
  K as WithRwAtom,
  wt as atomEffect,
  Q as atomFamily,
  U as atomWithCompare,
  X as atomWithDefault,
  Y as atomWithLazy,
  Z as atomWithObservable,
  tt as atomWithReducer,
  et as atomWithRefresh,
  st as atomWithReset,
  ot as atomWithStorage,
  nt as createJSONStorage,
  rt as deriveNestedAtom,
  at as freezeAtom,
  ut as freezeAtomCreator,
  ct as loadable,
  vt as observe,
  it as readAtom,
  lt as selectAtom,
  ft as splitAtom,
  dt as unstable_withStorageValidator,
  mt as unwrap,
  q as useAtomCallback,
  ht as useAtomState,
  J as useHydrateAtoms,
  N as useReducerAtom,
  L as useResetAtom,
  St as withAtomEffect,
  At as writeAtom
};
//# sourceMappingURL=index.js.map
